import { useMediaQuery } from '@mui/material';
import clsx from 'clsx';
import { ReactComponent as Logo } from '../../../assets/MyHand-logo.svg';
import { Menu, Socials } from '../../../components';
import CloseIcon from './CloseIcon.jsx';
import style from './style.module.scss';

const BurgerMenu = ({ open, menu, secondMenu, customSettings, handleClose, account, isUserConnected = false }) => {
    const isMobile = useMediaQuery(`(max-width : ${style.mobileBreakpoint})`);

    return (
        <>
            {!isMobile && <div className={clsx(style.backgroundOpacity, open && style.show)} onClick={handleClose} />}
            <div className={clsx(style.burgerMenu, open && style.open)}>
                <div>
                    <div className={style.top}>
                        <CloseIcon onClick={handleClose} />
                        <a href="/" className={style.logoContainer}>
                            <Logo />
                        </a>
                        {account}
                    </div>

                    <nav className={style.content}>
                        <Menu menu={menu} isFirstMenuMobile isUserConnected={isUserConnected} />
                        <Menu menu={secondMenu} isUserConnected={isUserConnected} />
                    </nav>
                </div>

                <Socials classNames={style.socials} {...customSettings} />
            </div>
        </>
    );
};

export default BurgerMenu;
